import {Component, EventEmitter, Input, Output} from '@angular/core';
import {LocalStorageService} from '../../shared/services/localStorage.service';
import {App, NavController, PopoverController} from 'ionic-angular';
import {Ce} from '../../shared/models/ce/ce.model';
import {BeneficiaireContextService, CeContextService} from '../../shared/services';
import {OauthService} from "../../shared/services/oauth.service";
import {WebSliderService} from "../../shared/services/webSlider.service";
import {CeService} from "../../shared/services/ce.service";

@Component({
    selector: 'core-footer',
    templateUrl: './footer.component.html',
})
export class FooterComponent {

    public ce: Ce;
    public paramCe: Ce;

    constructor(
        public navCtrl: NavController,
        private lsService: LocalStorageService,
        private ceContext: CeContextService,
        private ceService: CeService,
        public app: App
    ) {
        this.selectCE(this.ceContext.get());

        this.ceService.get(this.ce.code).subscribe(
        data => {
          this.paramCe = data.paramCe;
          console.log(data.paramCe);
        }
      );

    }

    selectCE(data) {
        this.ce = data;
        console.log(this.ce);
    }

  onClickInfosArticleList() {
    this.goToBlogArticleList('INFO');
  }

    onClickLegalArticleList() {
      this.goToBlogArticleList('LEGAL');
    }

  goToBlogArticleList(type) {
    const filters = {
      themeFilters: [],
      myDateStart: '',
      myDateEnd: '',
      orderBy: 'date',
      order: 'DESC',
      type: type
    };
    this.app.getRootNav().setRoot('BlogArticleListPage', {filters: filters, start: 1});
  }



}



// WEBPACK FOOTER //
// ./src/core/footer/footer.component.ts